import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import queryString from 'query-string';
import { Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import { Button } from 'components/Button';
import Text from 'components/Text';
import Login from 'pages/Login';

import pipefyLogo from 'img/pipefy-logo.svg';
import iconSuccess from 'img/success-img.svg';

import AuthServices from 'core/authentication/authService';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import UserService from 'services/user.service';

const PipefyClientId = process.env.REACT_APP_PIPEFY_CLIENT_ID;
const PipefyAuthUrl = process.env.REACT_APP_PIPEFY_AUTH_URL;
const AppUrl = process.env.REACT_APP_HOME_URL;
const PipefySAMLUrl = process.env.REACT_APP_PIPEFY_SAML_URL;

interface ErrorProps {
  isError: boolean,
  msg: string;
}

export default function OauthPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const userService = new UserService();
  const _authServices = new AuthServices();

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<ErrorProps>({
    isError: false,
    msg: ""
  });

  const [loadingUpdate, setLoadingUpdate] = useState(false);

  useEffect(() => {
    updatePipefyToken();
  }, []);

  const updatePipefyToken = () => {
    try {
      KeycloakPubServiceInstance.subscribe(async () => {
        const credentials = _authServices.credentials();
        const params = queryString.parse(location.search);

        if (credentials?.pipefy_token !== undefined) {
          setSuccess(true);

        } else if (params.code && params.code !== '') {
          setLoadingUpdate(true);

          userService.setPipefyToken(params.code as string, `${AppUrl}oauth`).then(async (response) => {
            setSuccess(true);

            await _authServices.refreshToken();

            if (credentials && response?.data) {
              credentials.pipefy_token = response.data;
              _authServices.save(credentials);
            }
          }).catch(() => {
            setError({
              isError: true,
              msg: "Não foi possível realizar a autorização. Tente novamente."
            });
            setSuccess(false);
          }).finally(() => {
            setLoadingUpdate(false);
          });
        }
      });
    } catch (error) {
      setError({
        isError: true,
        msg: "Erro geral ao atualizar o token Pipefy. Tente Novamente"
      });
    }
  };

  const loadPipefyUrl = () => {
    const callBackUrl = encodeURIComponent(`${AppUrl}oauth`);
    window.location.href = `${PipefySAMLUrl}?afterLoginRedirectTo=${encodeURIComponent(
      `${PipefyAuthUrl}/authorize?client_id=${PipefyClientId}&redirect_uri=${callBackUrl}&response_type=code&scope=read+write`
    )}`;
  };

  const releaseUser = () => {
    _authServices.refreshToken().then(() => {
      navigate('/dashboard');
    });
  };

  const isTextUpdate = loadingUpdate ? 'Atualizando...' : 'Autorizar Serviço';

  return (
    <Login noBottomLogo>
      <div className="animated fadeIn">
        <Column>
          <Row>
            <Text size={14} className="color-blue-gray text-wrap">
              Seja bem-vindo ao Custormer Care, uma plataforma de relacionamento
              da Mel - Especialista Viveo que irá facilitar sua interação
              com nossos clientes.
            </Text>
          </Row>
          <Row className="mt-3">
            <Text size={14} className="color-blue-gray text-wrap">
              Como este é seu primeiro acesso, precisamos fazer o seu vínculo ao
              Pipefy, nosso parceiro que irá auxiliar o seu fluxo de atendimento
              aos protocolos e solicitações dos clientes.
            </Text>
          </Row>
          <Row className="mt-5 mb-6 w-100" style={{ height: 270 }}>
            <Column
              className={`flex-1 mr-1 ${success ? 'pt-1 pb-4' : 'py-5'
                } align-center`}
              style={{ border: '2px solid rgba(54, 72, 99, 0.5)' }}
            >
              {success ? (
                <>
                  <img src={iconSuccess} alt="" />
                  <Text className="font-bold color-primary" size={14}>
                    Autorização realizada com sucesso
                  </Text>
                  <Text
                    className="color-blue-gray text-center text-wrap"
                    size={14}
                  >
                    Clique no botão abaixo para continuar seu acesso.
                  </Text>
                  <Row className="justify-center mt-5">
                    <Button
                      onClick={releaseUser}
                      className="bg-primary outline"
                      width="auto"
                    >
                      <Text className="color-primary px-5">Continuar</Text>
                    </Button>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Text className="font-bold color-primary pb-2" size={18}>
                      Integração de serviços
                    </Text>
                  </Row>
                  <Row className="pb-2">
                    <img src={pipefyLogo} alt="" />
                  </Row>
                  <Row>
                    <Text
                      className="color-blue-gray text-center text-wrap"
                      size={14}
                    >
                      Utilize o botão abaixo para autorizar a integração
                    </Text>
                  </Row>
                  <Row>
                    <Text
                      className="color-blue-gray text-center text-wrap pb-3"
                      size={14}
                    >
                      da sua conta do Customer Care com o Pipefy.
                    </Text>
                  </Row>
                  <Column className="pb-1">
                    <Button
                      disabled={loadingUpdate}
                      onClick={loadPipefyUrl}
                      className="outline"
                      width="auto"
                    >
                      <Text size={14} className="font-bold color-primary">
                        {isTextUpdate}
                      </Text>
                    </Button>

                    <Visibility visible={error.isError}>
                      <p className='color-danger p-1'>{error.msg}</p>
                    </Visibility>
                  </Column>
                </>
              )}
            </Column>
          </Row>
        </Column>
      </div>
    </Login>
  );
}
